import React from 'react'
import './style.scss'

const DashboardMainTitle = (props) => {
    return (
        <div className='dashboard-main-title'>
            <h1 className='text-center'>{props.children}</h1>
        </div>
    )
}

export default DashboardMainTitle
